import React, { useMemo, useState } from 'react';
function WithoutMemo({ input }: { input: number }) {
  const result = slowCalculation(input, 'withoutMemo');
  return (
    <div style={{ border: '2px solid red', padding: 16 }}>
      <h3>❌ Without useMemo</h3>
      <p>Calculation count: {calculationCounter.withoutMemo}</p>
      <p>Result: {result}</p>
    </div>
  );
}
const calculationCounter = {
  withoutMemo: 0,
  withMemo: 0,
};

function slowCalculation(n: number, label: 'withoutMemo' | 'withMemo') {
  calculationCounter[label]++;
  let total = 0;
  for (let i = 0; i < 1e7; i++) {
    total += Math.sqrt(i + n); // fake heavy work
  }
  return total.toFixed(2);
}
function WithMemo({ input }: { input: number }) {
  const result = useMemo(() => {
    return slowCalculation(input, 'withMemo');
  }, [input]);
  return (
    <div style={{ border: '2px solid green', padding: 16 }}>
      <h3>✅ With useMemo</h3>
      <p>Calculation count: {calculationCounter.withMemo}</p>
      <p>Result: {result}</p>
    </div>
  );
}
const Render = () => {
  const [input, setInput] = useState(0);
  const [renderTrigger, setRenderTrigger] = useState(0);
  return (
    <div style={{ padding: 20, width: '500px' }}>
      <h2>🧠 useMemo Real Demo</h2>
      <p>
        Change the input value to force recalculation. <br />
        Click the "Re-render" button to update the app **without** changing the input.
      </p>
      <div style={{ marginBottom: '20px' }}>
        <label>
          Input: &nbsp;
          <input type="number" className='text-black' value={input} onChange={(e) => setInput(Number(e.target.value))} />
        </label>
        <button style={{ marginLeft: '10px' }} onClick={() => setRenderTrigger((r) => r + 1)}>
          🔁 Re-render App
        </button>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
        <WithoutMemo input={input} />
        <WithMemo input={input} />
      </div>
    </div>
  );
};

export default Render;
